<!-- US-005 GAP-06: Pagina publica de pagamento da regua de cobranca -->
<div class="regua-publico-container">
    <div class="regua-publico-card">

        <!-- Header -->
        <div class="regua-header">
            <span class="logo-central-barra-top">
                <img *ngIf="logoUrl" [src]="logoUrl" alt="Logo da escola" class="logo">
                <img *ngIf="!logoUrl" src="assets/portal_logos.png" alt="logo_unidade" class="logo">
            </span>
            <h2>Pagamento de Parcela</h2>
            <p class="regua-header-unidade" *ngIf="unidade">{{ unidade }}</p>
        </div>

        <!-- Loading -->
        <div *ngIf="loading" class="regua-loading">
            <mat-spinner diameter="48"></mat-spinner>
            <p>Carregando dados do pagamento...</p>
        </div>

        <!-- Erro de conexao -->
        <div *ngIf="!loading && erro" class="regua-msg erro">
            <mat-icon>error_outline</mat-icon>
            <h3>Erro ao carregar</h3>
            <p>Nao foi possivel carregar os dados do pagamento. Tente novamente mais tarde.</p>
        </div>

        <!-- Link invalido -->
        <div *ngIf="!loading && !erro && invalido" class="regua-msg invalido">
            <mat-icon>link_off</mat-icon>
            <h3>Link invalido</h3>
            <p>Este link de pagamento nao foi encontrado ou expirou.</p>
        </div>

        <!-- Ja pago -->
        <div *ngIf="!loading && !erro && !invalido && pago" class="regua-msg pago">
            <mat-icon>check_circle</mat-icon>
            <h3>Pagamento confirmado</h3>
            <p>Ola, {{ nome }}! Esta parcela ja foi paga. Obrigado!</p>
        </div>

        <!-- Pendente (ativo) -->
        <ng-container *ngIf="!loading && !erro && !invalido && !pago">

            <!-- Saudacao -->
            <div class="regua-saudacao">
                <p>Ola, <strong>{{ nome }}</strong>!</p>
                <p>Segue abaixo os dados para pagamento da sua parcela do Curso Supletivo.</p>
            </div>

            <!-- Dados da parcela -->
            <div class="regua-valores">
                <div class="valor-linha">
                    <span>Vencimento:</span>
                    <strong>{{ dataVencimento }}</strong>
                </div>
                <div class="valor-linha total">
                    <span>Valor:</span>
                    <strong>{{ valor | currency:'BRL':'symbol':'1.2-2' }}</strong>
                </div>
            </div>

            <!-- Toggle de forma de pagamento -->
            <div class="metodo-pagamento-toggle">
                <h4>Forma de pagamento</h4>
                <div class="toggle-buttons">
                    <button mat-raised-button
                            [color]="metodoSelecionado === 'pix' ? 'primary' : ''"
                            (click)="selecionarMetodo('pix')"
                            [disabled]="!pixCodigo">
                        <mat-icon>qr_code</mat-icon> Pix
                    </button>
                    <button mat-raised-button
                            [color]="metodoSelecionado === 'cartao' ? 'primary' : ''"
                            (click)="selecionarMetodo('cartao')">
                        <mat-icon>credit_card</mat-icon> Cartao
                    </button>
                    <button mat-raised-button
                            [color]="metodoSelecionado === 'boleto' ? 'primary' : ''"
                            (click)="selecionarMetodo('boleto')"
                            [disabled]="!linhaDigitavel">
                        <mat-icon>receipt</mat-icon> Boleto
                    </button>
                </div>
            </div>

            <!-- SECAO PIX -->
            <ng-container *ngIf="metodoSelecionado === 'pix'">
                <div class="regua-pix" *ngIf="pixBase64">
                    <h4>Escaneie o QR Code para pagar</h4>
                    <img [src]="'data:image/png;base64,' + pixBase64"
                         alt="QR Code Pix"
                         class="qrcode-img">
                </div>
                <div class="regua-pix" *ngIf="pixCodigo">
                    <h4>Pix Copia e Cola</h4>
                    <div class="pix-codigo">
                        <textarea readonly rows="3">{{ pixCodigo }}</textarea>
                        <button mat-raised-button color="primary" (click)="copiarPix()">
                            <mat-icon>content_copy</mat-icon>
                            {{ pixCopiado ? 'Copiado!' : 'Copiar codigo Pix' }}
                        </button>
                    </div>
                </div>
            </ng-container>

            <!-- SECAO CARTAO -->
            <ng-container *ngIf="metodoSelecionado === 'cartao'">

                <!-- Sucesso pos-pagamento -->
                <div *ngIf="pagamentoCartaoSucesso" class="regua-msg pago">
                    <mat-icon>check_circle</mat-icon>
                    <h3>Pagamento realizado com sucesso!</h3>
                    <div class="sucesso-info">
                        <div class="sucesso-linha" *ngIf="transacaoId">
                            <span class="sucesso-label">Número da transação:</span>
                            <strong>#{{ transacaoId }}</strong>
                        </div>
                        <div class="sucesso-linha">
                            <span class="sucesso-label">Data/Hora:</span>
                            <strong>{{ dataHoraPagamento | date:'dd/MM/yyyy \'às\' HH:mm' }}</strong>
                        </div>
                        <div class="sucesso-linha">
                            <span class="sucesso-label">Valor pago:</span>
                            <strong>{{ valor | currency:'BRL':'symbol':'1.2-2' }}</strong>
                        </div>
                        <p class="sucesso-obs">Um comprovante será enviado para o e-mail cadastrado.</p>
                    </div>
                </div>

                <div class="regua-cartao" *ngIf="!pagamentoCartaoSucesso">

                    <!-- Instrucao -->
                    <div class="instrucao-cartao">
                        <mat-icon>info_outline</mat-icon>
                        <p>Preencha os dados do seu cartão de crédito para concluir o pagamento.</p>
                    </div>

                    <!-- Valor a pagar -->
                    <div class="valor-display">
                        <span class="valor-display-label">Valor do pagamento</span>
                        <span class="valor-display-valor">{{ valor | currency:'BRL':'symbol':'1.2-2' }}</span>
                    </div>

                    <!-- Visual do cartao -->
                    <app-draw-credit #drawCreditCard [cardData]="cardData"></app-draw-credit>

                    <form [formGroup]="cartaoForm" (ngSubmit)="pagarComCartao()">

                        <mat-form-field appearance="outline" class="campo-full">
                            <mat-label>Número do cartão</mat-label>
                            <input matInput formControlName="numero"
                                   mask="0000 0000 0000 0000"
                                   placeholder="0000 0000 0000 0000"
                                   (focus)="drawCreditCard.unflip()">
                            <mat-error>Informe o número do cartão</mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="campo-full">
                            <mat-label>Nome impresso no cartão</mat-label>
                            <input #nomeInput matInput formControlName="nome"
                                   maxlength="50"
                                   appTitlecase
                                   (focus)="drawCreditCard.unflip()">
                            <mat-hint align="end">{{ nomeInput.value?.length || 0 }}/50</mat-hint>
                            <mat-error>Informe o nome como aparece no cartão</mat-error>
                        </mat-form-field>

                        <div class="campos-row">
                            <mat-form-field appearance="outline" class="campo-half">
                                <mat-label>Validade</mat-label>
                                <input matInput [matDatepicker]="dp" formControlName="validade"
                                       placeholder="MM/AAAA" readonly [min]="minDateValidade"
                                       (focus)="drawCreditCard.unflip()">
                                <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                                <mat-datepicker #dp startView="multi-year"
                                    (monthSelected)="closeDatePicker($event, dp)">
                                </mat-datepicker>
                                <mat-error>Selecione a validade do cartão</mat-error>
                            </mat-form-field>
                            <mat-form-field appearance="outline" class="campo-half">
                                <mat-label>CVV</mat-label>
                                <input matInput formControlName="codigo"
                                       mask="0009"
                                       placeholder="000"
                                       maxlength="4"
                                       (focus)="drawCreditCard.flip()">
                                <mat-error>Informe o CVV</mat-error>
                            </mat-form-field>
                        </div>

                        <mat-form-field appearance="outline" class="campo-full" *ngIf="maxParcelas > 1">
                            <mat-label>Parcelas</mat-label>
                            <mat-select formControlName="parcelas">
                                <mat-option *ngFor="let p of opcoesParcelamento" [value]="p">
                                    {{ p }}x de {{ (valor / p) | currency:'BRL':'symbol':'1.2-2' }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <!-- RF-09: CPF do titular do cartão -->
                        <div class="cpf-titular-section">
                            <mat-checkbox formControlName="informarCpfTitular">
                                Informar CPF do titular do cartão
                            </mat-checkbox>
                            <mat-form-field appearance="outline" class="campo-full"
                                            *ngIf="cartaoForm.get('informarCpfTitular').value">
                                <mat-label>CPF do titular</mat-label>
                                <input matInput formControlName="cpfTitular"
                                       mask="000.000.000-00" placeholder="000.000.000-00">
                            </mat-form-field>
                        </div>

                        <div class="erro-cartao" *ngIf="erroCartao">
                            <mat-icon>warning</mat-icon>
                            {{ erroCartao }}
                        </div>

                        <button mat-raised-button color="primary" type="submit"
                                class="btn-pagar-cartao"
                                [disabled]="cartaoForm.invalid || processandoCartao">
                            <mat-spinner *ngIf="processandoCartao" diameter="20" class="spinner-inline"></mat-spinner>
                            <mat-icon *ngIf="!processandoCartao">credit_card</mat-icon>
                            {{ processandoCartao ? 'Processando...' : cartaoForm.get('parcelas').value > 1 ? 'Pagar ' + cartaoForm.get('parcelas').value + 'x de ' + (valor / cartaoForm.get('parcelas').value | currency:'BRL':'symbol':'1.2-2') : 'Pagar com Cartão' }}
                        </button>

                        <!-- Badge de seguranca -->
                        <div class="seguranca-badge">
                            <mat-icon>lock</mat-icon>
                            <span>Pagamento seguro com criptografia SSL</span>
                        </div>

                    </form>
                </div>
            </ng-container>

            <!-- SECAO BOLETO -->
            <ng-container *ngIf="metodoSelecionado === 'boleto'">
                <div class="regua-boleto" *ngIf="linhaDigitavel">
                    <h4>Codigo do boleto</h4>
                    <div class="boleto-codigo">
                        <textarea readonly rows="2">{{ linhaDigitavel }}</textarea>
                        <button mat-raised-button color="primary" (click)="copiarCodigo()">
                            <mat-icon>content_copy</mat-icon>
                            {{ codigoCopiado ? 'Copiado!' : 'Copiar codigo de barras' }}
                        </button>
                    </div>
                    <p class="boleto-instrucao">
                        Copie o codigo acima e cole no aplicativo do seu banco para pagar via boleto ou Pix.
                    </p>
                </div>
            </ng-container>

            <!-- Copiar link -->
            <div class="regua-copiar-link">
                <button mat-stroked-button (click)="copiarLink()">
                    <mat-icon>link</mat-icon>
                    {{ linkCopiado ? 'Link copiado!' : 'Copiar link desta pagina' }}
                </button>
            </div>

            <!-- Rodape -->
            <div class="regua-rodape" *ngIf="unidade">
                <p>Se o pagamento ja foi realizado ou o debito ja foi negociado, desconsidere esta mensagem.</p>
                <p class="rodape-unidade"><strong>{{ unidade }}</strong> | supletivo preparatorio</p>
            </div>

        </ng-container>

    </div>
</div>
